import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};

  .popup-footer {
    display: flex;
    align-items: center;
  }

  .btn-description {
    margin-left: 16px;
    line-height: 16px;

    .second-line {
      margin-top: 2px;
    }

    .red {
      color: ${({ theme }) => theme.colors.color_red};
    }

    .gray {
      color: ${({ theme }) => theme.colors.color_darkgray};
    }

    .small {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }

  @media screen and (max-width: 646px) {
    .popup-footer {
      flex-direction: column;

      .first {
        order: 1;
      }

      .second {
        order: 2;
        margin-top: 12px;
      }
    }

    .btn-description {
      margin-left: 0;
      margin-top: 12px;
      text-align: center;
    }

    .btn-description.first {
      margin-top: 0;
    }
  }
`;

export const ConfirmationPopupStyles = styled.div`
  .description {
    margin-bottom: 16px;
  }
`;

export const Block = styled.div`
  display: flex;
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.color_bg};

  .icon {
    margin-right: 12px;
  }

  .header {
    font-weight: bold;
  }

  .text {
    line-height: 20px;
    margin-top: 4px;
  }

  @media screen and (max-width: 646px) {
    & {
      flex-direction: column;

      .icon {
        margin-right: 0;
        margin-bottom: 12px;
      }
    }
  }
`;

export const ErrorMessage = styled.div`
  padding: 15px 0px 0px;
  color: ${({ theme }) => theme.colors.color_red};
`;
